class WebCamPreviewManager {
  private Dictionary: Map<string, MediaStream> = new Map();

  constructor() {}

  async getStream(deviceId: string) {
    const source = this.Dictionary.get(deviceId);
    if (source && source.active) {
      return source;
    }

    return null;
  }

  setStream(deviceId: string, stream: MediaStream) {
    this.Dictionary.set(deviceId, stream);
  }

  destroy(deviceId?: string) {
    if (deviceId) {
      const stream = this.Dictionary.get(deviceId);
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
        this.Dictionary.delete(deviceId);
      }
    } else {
      this.Dictionary.forEach((stream) => {
        stream.getTracks().forEach((track) => track.stop());
      });
      this.Dictionary.clear();
    }
  }
}

export default new WebCamPreviewManager();
